export const LOGOFF_SUCCESS = "LOGOFF_SUCCESS";
export const UPDATE_ROUTE_INFO = "UPDATE_ROUTE_INFO";
export const GET_USERID_FOR_HEADER_AJAX_SUCCESS = "GET_USERID_FOR_HEADER_AJAX_SUCCESS";
